module.exports = __webpack_public_path__ + "img/primary_4x4_z16.e5a19735.svg";